module.exports = __webpack_public_path__ + "static/dinosaurmain-b9a3919865d15120efbd93e61ba50676.png";